module.exports = __webpack_public_path__ + "img/ctrl-givens-stub-+.d5264f23.svg";